import React, { useEffect, useRef } from 'react';
// import { ArrowDownIcon } from '@heroicons/react/24/outline';
import './ThreeColumnVideos.css'; // Import CSS file

// Expanded to 9 items with author images
const items = [
  { title: '"Manon of the Water"', videoSrc: '/videos/manon.mp4', authorImg: '/images/reviewers/cory.jpg' },
  { title: '"Orient Express"', videoSrc: '/videos/orientexpress.mp4', authorImg: 'https://i.pravatar.cc/150?img=2' },
  { title: '"AroundWorld80Days.pdf"', videoSrc: '/videos/aroundworld.mp4', authorImg: '/images/reviewers/sarah.jpg' },
  { title: '"Gengis Khan Modern World"', videoSrc: '/videos/gengis1.mp4', authorImg: '/images/reviewers/emilio.jpg' },
  { title: '"Harry Potter Order of the Phoenix""', videoSrc: '/videos/orderphoenix.mp4', authorImg: 'https://i.pravatar.cc/150?img=5' },
  { title: '"Greenwitch"', videoSrc: '/videos/greenwitch.mp4', authorImg: 'https://i.pravatar.cc/150?img=6' },
  { title: '"Dracula"', videoSrc: '/videos/dracula.mp4', authorImg: '/images/reviewers/nogo.jpg' },
  { title: 'Indiana Jones Raiders of the Lost Ark', videoSrc: '/videos/lostark.mp4', authorImg: 'https://i.pravatar.cc/150?img=8' },
  { title: 'Death on the Nile', videoSrc: '/videos/deathnile.mp4', authorImg: '/images/reviewers/comedreams.jpg' },
];

export default function ThreeColumnVideos() {
  const carouselRef = useRef(null);
  
  useEffect(() => {
    // Auto-scroll the carousel in an infinite loop
    const interval = setInterval(() => {
      if (carouselRef.current) {
        const scrollAmount = 450; // Adjusted to match new item width
        const currentScroll = carouselRef.current.scrollLeft;
        const maxScroll = carouselRef.current.scrollWidth - carouselRef.current.clientWidth;
        
        // If we've reached the end, go back to start
        if (currentScroll >= maxScroll - 50) {
          // Use smooth behavior for better UX
          carouselRef.current.scrollTo({
            left: 0,
            behavior: 'smooth'
          });
        } else {
          // Otherwise continue scrolling
          carouselRef.current.scrollBy({
            left: scrollAmount,
            behavior: 'smooth'
          });
        }
      }
    }, 5000); // Scroll every 5 seconds
    
    return () => clearInterval(interval);
  }, []);

  return (
    <section className="video-carousel-section">
      <div className="carousel-container" ref={carouselRef}>
        <div className="carousel-track">
          {items.map(({ title, videoSrc, authorImg }, idx) => (
            <div key={idx} className="carousel-item">
              <div className="column-item-header">
                <img 
                  src={authorImg} 
                  alt={`Author of ${title}`} 
                  className="author-image"
                />
                <h3 className="column-item-title">{title}</h3>
              </div>

              {/* Video */}
              <div className="column-video-wrapper">
                <video
                  controls
                  muted
                  autoPlay
                  loop
                  playsInline
                  className="column-video-player"
                >
                  <source src={videoSrc.replace('.mp4', '.webm')} type="video/webm" />
                  <source src={videoSrc} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
} 